import { DistributorsItems, DistributorsTitle } from "./constants";

export const MobileInfoHeader = (props) => {
  const ZoneId = props.ZoneId;

  return <div className='mobile-info-header'>
    <div className="distributors-card">
      <h2>{DistributorsTitle}</h2>
      <hr className='separator' />
      <ul>
        {DistributorsItems.filter(x => x.zoneId === ZoneId).map((item) => {
          return <li key={`online-distributor-${item.id}`} className='card-item'>
            <h3 className="distributor-name">{item.name}</h3>
            <a href={item.url}>{item.url}</a>
          </li>
        })}
      </ul>
    </div>
  </div>;
}